<template>
  <DxPopup
    :visible="popupConfig.visible"
    :drag-enabled="true"
    :close-on-outside-click="false"
    :show-title="true"
    :width="'90%'"
    :height="'80%'"
    :title="'Storage Location Selection'"
    :showCloseButton="false"
    :wrapperAttr="{ class: 'css-v2 gc-popup gc-popup-work-order-so-lines' }"
  >
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />
    <div class="css-v2 transaction-list">
      <gc-filter-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
        :rightContainerWidth="250"
      >
        <template #leftContent>
          <dx-data-grid
            v-if="popupConfig.visible"
            :columnChooser="{
              enabled: false,
            }"
            :pager="{ visible: false }"
            :columns="getSalesGridColumns"
            :data-source="dataSourceConfig"
            :row-alternation-enabled="true"
            :selection="{
              mode: 'single',
            }"
            :height="getGridHeight"
            :width="'100%'"
            @toolbar-preparing="onToolbarPreparing($event)"
            @selection-changed="onSelectionChanged"
            @content-ready="onContentReady"
            @row-dbl-click="onRowDblClick"
            :ref="'storagelocation-list-grid'"
          >
            <DxSearchPanel :visible="false" />
            <template #Record="{ data }">
              <GcRecord
                :data="data"
                :primary="data.column['cellTemplateRecord']['primary']"
                :secondary="data.column['cellTemplateRecord']['secondary']"
              />
            </template>

            <template #Decimal="{ data }">
              <GcDecimal :dataValue="data" :format="data.column.format" />
            </template>

            <template #Status="{ data }">
              <GcStatusChip
                :status="data.data[data.column.dataField]"
                v-if="data.data[data.column.dataField]"
                :customBackGroundColor="
                  data.column.customBackGroundColor
                    ? data.column.customBackGroundColor
                    : undefined
                "
                :data="data.data"
              />
            </template>
          </dx-data-grid>
        </template>
        <template #rightContent>
          <LocationSelectFilter
            :toolbar="filterToolbar"
            :heightAdjustment="filterHeightAdjustment"
            :setGridPanelFilter="setGridPanelFilter"
          />
        </template>
      </gc-filter-split-view>
    </div>
  </DxPopup>
</template>

<script>
import BaseViewMixin from "../v1/_mixins/base.view";
import { SalesOrderService } from "../_services/api/sales/sales-order.service";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import ColumnWidth from "../_helpers/data-grid/ColumnWidth";
import { ProductAttributeService } from "../_services/api/settings/products/product-attribute.service";
import LocationSelectFilter from "../components/inventory/gc-bin-list-selection-filter-panel";

export default {
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    addSelectedSlLines: {
      type: Function,
      default: () => {},
    },
    preSelectedItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: { LocationSelectFilter },
  mixins: [BaseViewMixin, DataGridMixin],
  data() {
    return {
      showLeftContainer: true,
      showRightContainer: true,
      AttributeName: undefined,
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
          },
        },
      },
      selectedItems: [],
      initiateDataLoading: false,
      defaultFilterValues: [],
      setGridHeight: "auto",
      filterHeightAdjustment: 0,
      AttributeTableDefinitionRecordId: undefined,
      AttributeColumnDefinition: undefined,
    };
  },
  beforeMount() {
    if (
      this.popupConfig.dataModel &&
      this.popupConfig.dataModel.CurrentLocationRecordId
    ) {
      this.defaultFilterValues = [
        ["RecordId", "<>", this.popupConfig.dataModel.CurrentLocationRecordId],
      ];
    }
  },
  async mounted() {
    this.initiateDataLoading =
      (await this.filterFormItems.filter((x) => x.filterDefaultValue).length) ==
      0
        ? true
        : false;
  },
  async created() {
    await this.getAttributeTableDefinition();
    await this.getAttributeColumnDefinition();
    setTimeout(() => {
      this.setGridHeight = this.filterHeightAdjustment =
        document.querySelectorAll(
          ".gc-popup-work-order-so-lines .dx-popup-content"
        )[0].clientHeight - 20;
    }, 1);
  },
  computed: {
    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            text: "Select",
            stylingMode: "contained",
            type: "success",
            onClick: this.addSoLines,
            disabled: this.selectedItems.length === 0,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            text: "Cancel",
            stylingMode: "outlined",
            type: "danger",
            onClick: this.popupHidden,
          },
        },
      ];
    },

    getGridHeight() {
      return this.setGridHeight;
    },

    popupVisible() {
      return this.setVisible ? true : false;
    },

    getSalesGridColumns() {
      return this.parseColumnWithScreenFields([
        {
          screenField: "ColumnValue",
          filterIndex: 1,
          caption: "Location",
          gridDataField: "Name",
          filterLabel: "Location",
          filterDataField: "LocationSearchText",
          dataType: "string",
          type: "Text",
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.Name}
                        </span> <br />
                      <span class="record-secondary gc-grid-code">
                        ${info.data.Code}
                      </span>
                    </div>`);
          },
          allowHiding: false,
        },
        {
          screenField: "Code",
          gridDataField: "Code",
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "BinLocationType",
          gridDataField: "Type",
          dataField: "Type",
          visible: true,
          cellTemplate: undefined,
        },
        {
          screenField: "Branch",
          gridDataField: "Branch",
          filterDataField: "Branch",
          dataField: "Branch",
          width: ColumnWidth.BranchCode.width,
          maxWidth: ColumnWidth.BranchCode.width,
          filterIndex: 2,
          exportFields: false,
          cellTemplate: undefined,
        },
        {
          screenField: "ColumnValue",
          caption: "Site",
          gridDataField: "Site",
          dataField: "Site",
          filterDataField: "SiteRecordId",
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          filterLabel: "Site",
          dataSourceConfig: this.getAttributeFilterData("Site"),
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 3,
          type: "String",
          sortIndex: 0,
          sortOrder: "asc",
          allowSorting: true,
        },
        {
          screenField: "ColumnValue",
          caption: "Building",
          gridDataField: "Building",
          dataField: "Building",
          filterDataField: "BuildingRecordId",
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Building"),
          filterLabel: "Building",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 4,
          sortIndex: 1,
          sortOrder: "asc",
          allowSorting: true,
        },
        {
          screenField: "ColumnValue",
          caption: "Area",
          gridDataField: "Area",
          dataField: "Area",
          filterDataField: "AreaRecordId",
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Area"),
          filterLabel: "Area",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 5,
          sortIndex: 2,
          sortOrder: "asc",
          allowSorting: true,
        },
        {
          screenField: "ColumnValue",
          caption: "Aisle",
          gridDataField: "Aisle",
          dataField: "Aisle",
          filterDataField: "AisleRecordId",
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Aisle"),
          filterLabel: "Aisle",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          alignment: "left",
          filterIndex: 6,
          sortIndex: 3,
          sortOrder: "asc",
          allowSorting: true,
        },
        {
          screenField: "ColumnValue",
          caption: "Bay",
          gridDataField: "Bay",
          dataField: "Bay",
          filterDataField: "BayRecordId",
          visible: false,
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Bay"),
          filterLabel: "Bay",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 7,
        },
        {
          screenField: "ColumnValue",
          caption: "Space",
          gridDataField: "Space",
          dataField: "Space",
          filterDataField: "SpaceRecordId",
          visible: false,
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Space"),
          filterLabel: "Space",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 8,
        },
        {
          screenField: "ColumnValue",
          caption: "Shelf",
          gridDataField: "Shelf",
          dataField: "Shelf",
          filterDataField: "ShelfRecordId",
          visible: false,
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Shelf"),
          filterLabel: "Shelf",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 9,
        },
      ]);
    },

    dataSourceConfig() {
      if (this.initiateDataLoading) {
        return this.originalDataSourceConfig;
      } else {
        return [];
      }
    },
    originalDataSourceConfig() {
      return SalesOrderService.dataSourceConfig("api/StorageLocationList", {
        key: ["RecordId"],
        filter: this.defaultFilterValues.length
          ? this.defaultFilterValues
          : null,
        keyType: {
          SiteRecordId: "Guid",
          BuildingRecordId: "Guid",
          AreaRecordId: "Guid",
          AisleRecordId: "Guid",
          RecordId: "Guid",
        },
      });
    },

    /**
     * Retun filter panel form items
     * filterIndex field does have an impact , because we directly inject the fields in to the filter panel.
     * since it's a direct inject, field order is the order we define it. - SD
     */
    filterFormItems() {
      return [
        {
          screenField: "ColumnValue",
          filterLabel: "Location",
          filterDataField: "LocationSearchText",
          dataType: "string",
          type: "Text",
        },
        {
          screenField: "Branch",
          gridDataField: "Branch",
          filterDataField: "Branch",
          width: ColumnWidth.BranchCode.width,
          maxWidth: ColumnWidth.BranchCode.width,
          cellTemplate: undefined,
        },
      ];
    },
  },
  methods: {
    onRowDblClick(e) {
      this.addSelectedSlLines([e.data]);
      this.popupConfig.visible = false;
    },
    popupHidden() {
      this.popupConfig.visible = false;
    },

    /**
     * Filter Panel values
     * @param e
     * @param valueChanged
     */

    // eslint-disable-next-line no-unused-vars
    setGridPanelFilter(e, valueChanged) {
      let dataGrid = this.$refs["storagelocation-list-grid"].instance;

      let filter = [];
      if (this.defaultFilterValues.length > 0) {
        filter = [...this.defaultFilterValues];
      }

      if (e.length === 0 && valueChanged && filter.length > 0) {
        dataGrid.filter(filter);
        dataGrid.refresh(true);
      } else {
        if (this.initiateDataLoading == false) {
          dataGrid.option("dataSource", this.originalDataSourceConfig);
          this.initiateDataLoading = true;
        }

        if (e.length > 0) {
          if (filter.length > 0) {
            filter.push("and");
          }
          filter.push(e);
        }

        if (dataGrid) {
          if (filter.length > 0) dataGrid.filter(filter);
          else dataGrid.clearFilter();

          dataGrid.refresh(true);
        }
      }
    },

    onToolbarPreparing(e) {
      e.toolbarOptions.items.push({
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        options: {
          validationGroup: "formsData",
          icon: "filter",
          elementAttr: { id: "filter-btn" },
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            var item = document.getElementById("filter-btn");
            this.$logger.debug("item ", item);
            item.classList.add("dx-state-invisible");

            setTimeout(() => {
              this.reSizeGrid();
            }, 50);
          },
          visible: !this.showRightContainer,
        },
      });
    },

    /**
     * on data grid line selected
     */
    onSelectionChanged(e) {
      this.selectedItems = e.selectedRowsData;
    },

    onContentReady(e) {
      if (this.preSelectedItems.length > 0) {
        let grid = e.component;
        if (grid) {
          let IDs = [];
          this.preSelectedItems.forEach((element) => {
            IDs.push({
              SalesOrderCode: element.SalesOrderCode,
              SalesOrderLine: element.SalesOrderLine,
            });
          });

          grid.selectRows(IDs, true);
        }
      }

      this.addGridNoResults(e, undefined);
    },

    addSoLines() {
      this.addSelectedSlLines(this.selectedItems);
      this.popupConfig.visible = false;
    },
    getAttributeFilterData(AttributeName) {
      return {
        endpoint: "api/AttributeColumnValueLookup",
        sort: {
          selector: "ColumnValue",
          asc: true,
        },
        filter: [
          [
            "AttributeColumnDefinitionRecordId",
            "=",
            this.getAttributeColumnDefinitionRecordId(AttributeName),
          ],
        ],
        select: [
          "AttributeColumnDefinitionRecordId",
          "RecordId",
          "ColumnValue",
        ],
        keyType: {
          AttributeColumnDefinitionRecordId: "Guid",
          RecordId: "Guid",
        },
      };
    },
    getAttributeColumnDefinitionRecordId(AttributeName) {
      if (!this.AttributeColumnDefinition) {
        return null; // if no record is found
      }
      const record = this.AttributeColumnDefinition.find(
        (a) => a.AttributeName === AttributeName
      );

      if (record) {
        return record.RecordId; // return null if not valid GUID
      }

      return null; // if no record is found
    },
    async getAttributeTableDefinition() {
      var result = await ProductAttributeService.getAttributeTableDefinition();

      this.AttributeTableDefinitionRecordId = result.data.value[0].RecordId;
    },
    async getAttributeColumnDefinition() {
      var result = await ProductAttributeService.getAttributeColumnDefinition(
        `AttributeTableDefinitionRecordId eq ${this.AttributeTableDefinitionRecordId} and DataSourceType eq 'Value Lookup'`
      );

      this.AttributeColumnDefinition = result.data.value;
    },
  },
};
</script>

<style lang="scss">
.gc-popup-work-order-so-lines {
  .footer {
    .dx-button:first-child {
      margin-right: 12px;
    }
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand) {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
    vertical-align: top !important;
  }

  .advance-filter-panel .dx-form {
    padding-bottom: 10px !important;
  }
}
</style>
